import { render, staticRenderFns } from "./product-table.vue?vue&type=template&id=1e58c8d8"
import script from "./product-table.vue?vue&type=script&lang=js"
export * from "./product-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports